import { stringify, parse } from 'qs';

export function queryParse(queryStr) {
  let str = queryStr;
  if (!str) return {};
  if (typeof str !== 'string') return {};
  if (str.indexOf('?') !== -1) {
    [, str] = str.split('?');
  }
  return parse(str);
}
export function queryString(queryObj) {
  return stringify(queryObj);
}



// WEBPACK FOOTER //
// ./src/utils/query.js